import { render, staticRenderFns } from "./relativeBrand.vue?vue&type=template&id=43eed602"
import script from "./relativeBrand.vue?vue&type=script&lang=js"
export * from "./relativeBrand.vue?vue&type=script&lang=js"
import style0 from "./relativeBrand.vue?vue&type=style&index=0&id=43eed602&prod&lang=scss"
import style1 from "./relativeBrand.vue?vue&type=style&index=1&id=43eed602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports